import React, { Component } from 'react';
import axios from 'axios';
import { Form, Header, Message, Segment } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { fetchAcademicYears, fetchAllAcademicYears, fetchMarks } from '../Lookups/util';
import CourseGradingTable from '../Professor/ProfessorInputGrades/CourseGradingTable';

const OTHER_ACTIVITIES_VALUE = 'OTHER_ACTIVITIES';

class NonCycleStudentGradingList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            filteredCourses: [],
            searchResults: [],
            marks: [],
            courseOptions: [],
            selectedCourseId: null,
            searchText: '',
            loading: false,
            error: false,
            academicYears: [],
            selectedAcademicYearId: null,
            nonCyclePrograms: [],
            selectedNonCycleProgramId: null,
        };
    }

    componentDidMount() {
        this.setState({ loading: true });
        Promise.all([
            axios.get('/non-cycle-student-ou-course/grading'),
            fetchMarks(),
            fetchAcademicYears(),
            axios.get('/non-cycle-programs/grading'),
            axios.get('/external-student-course/grading/non-cycle'),
        ])
            .then(([coursesRes, marksRes, academicYearsRes, nonCycleProgramsRes, externalCoursesRes]) => {
                const allCourses = [
                    ...coursesRes.data,
                    ...externalCoursesRes.data.map(c => ({
                        ...c,
                        _isExternalStudent: true
                    })),
                ];

                const marks = marksRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length)
                        ? el.translations.find(e => e.language === window.$locale).displayName
                        : el.displayName),
                }));

                const courseOptions = Array.from(
                    new Map(
                        allCourses
                            .filter(c => !c.isActivity)
                            .map(c => [c.courseBasicId, {
                                key: c.courseBasicId,
                                value: c.courseBasicId,
                                text: c.courseName,
                            }])
                    ).values()
                );

                if (allCourses.some(c => c.isActivity)) {
                    courseOptions.unshift({
                        key: OTHER_ACTIVITIES_VALUE,
                        value: OTHER_ACTIVITIES_VALUE,
                        text: <FormattedMessage id="externalStudent.otherActivityTypes"/>,
                    });
                }

                const sortedAcademicYears = academicYearsRes.data.sort((a, b) => b.startYear - a.startYear);

                this.setState({
                    courses: allCourses,
                    filteredCourses: allCourses,
                    marks,
                    courseOptions,
                    academicYears: sortedAcademicYears,
                    selectedAcademicYearId: sortedAcademicYears.length > 0 ? sortedAcademicYears[0].id : null,
                    nonCyclePrograms: nonCycleProgramsRes.data,
                    loading: false,
                }, this.applyFilters);
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: true
                });
            });
    }

    applyFilters = () => {
        const {
            courses,
            searchText,
            searchResults,
            selectedCourseId,
            selectedAcademicYearId,
            selectedNonCycleProgramId
        } = this.state;
        let result = searchText ? searchResults : courses;
        if (selectedAcademicYearId) {
            result = result.filter(c => c.academicYearId === selectedAcademicYearId);
        }
        if (selectedCourseId) {
            if (selectedCourseId === OTHER_ACTIVITIES_VALUE) {
                result = result.filter(c => c.isActivity === true && c.courseStudyProgramId === null);
            } else {
                result = result.filter(c => c.courseBasicId === selectedCourseId);
            }
        }
        if (selectedNonCycleProgramId) {
            result = result.filter(c => c.nonCycleProgramId === selectedNonCycleProgramId);
        }
        this.setState({ filteredCourses: result });
    };

    handleCourseFilterChange = (value) => {
        this.setState({ selectedCourseId: value || null }, this.applyFilters);
    };

    handleSearchTextChange = (value) => {
        this.setState({ searchText: value });
    };

    getSearchResults = (results) => {
        this.setState({ searchResults: results }, this.applyFilters);
    };

    handleSave = (editingRowId, editedRowData) => {
        const course = this.state.courses.find(c => c.id === editingRowId);
        const putUrl = course && course._isExternalStudent
            ? '/external-student-course'
            : '/non-cycle-student-ou-course';

        return axios.put(putUrl, {
            id: editingRowId,
            markId: editedRowData.markId || null,
            dateOfExam: editedRowData.dateOfExam ? new Date(editedRowData.dateOfExam) : null,
        })
            .then(() => Promise.all([
                axios.get('/non-cycle-student-ou-course/grading'),
                axios.get('/external-student-course/grading/non-cycle'),
            ]))
            .then(([ncRes, extRes]) => {
                const allCourses = [
                    ...ncRes.data,
                    ...extRes.data.map(c => ({
                        ...c,
                        _isExternalStudent: true
                    })),
                ];
                this.setState({ courses: allCourses }, this.applyFilters);
                toast(<FormattedMessage id="externalStudent.toast.courseUpdated"/>);
            })
            .catch(() => {
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                throw new Error();
            });
    };

    handleShowDetails = (course) => {
        if (course._isExternalStudent) {
            localStorage.setItem('externalStudentId', course.externalStudentId);
            this.props.history.push('/dolazne-mobilnosti/student');
        } else {
            localStorage.setItem('nonCycleStudentId', course.nonCycleStudentId);
            this.props.history.push('/neciklicni-studij/student');
        }
    };

    render() {
        const {
            courses,
            filteredCourses,
            marks,
            courseOptions,
            selectedCourseId,
            loading,
            academicYears,
            selectedAcademicYearId,
            nonCyclePrograms,
            selectedNonCycleProgramId,
        } = this.state;

        return (
            <div>
                <h2><FormattedMessage id="externalStudent.nonCycleStudyProgram"/></h2>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3" style={{ margin: 0 }}>
                            <FormattedMessage id="sidebar.grading"/>
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Select
                                    fluid
                                    label={<FormattedMessage id="externalStudent.academicYear"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                    clearable
                                    options={academicYears.map(el => ({
                                        key: el.id,
                                        text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length)
                                            ? el.translations.find(e => e.language === window.$locale).name
                                            : el.name),
                                        value: el.id
                                    }))}
                                    value={selectedAcademicYearId}
                                    onChange={(e, { value }) => this.setState({ selectedAcademicYearId: value || null }, this.applyFilters)}
                                />
                                <Form.Select
                                    fluid
                                    label={<FormattedMessage id="externalStudent.course"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectCourse"/>}
                                    clearable
                                    options={courseOptions}
                                    value={selectedCourseId}
                                    onChange={(e, { value }) => this.handleCourseFilterChange(value)}
                                />
                                <Form.Select
                                    fluid
                                    label={<FormattedMessage id="externalStudent.nonCycleProgram"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectNonCycleProgram"/>}
                                    clearable
                                    options={nonCyclePrograms.map(p => ({
                                        key: p.id,
                                        value: p.id,
                                        text: p.programName,
                                    }))}
                                    value={selectedNonCycleProgramId}
                                    onChange={(e, { value }) => this.setState({ selectedNonCycleProgramId: value || null }, this.applyFilters)}
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Message>
                            U prikazanoj tabeli se vrši pregled i unos ocjena za studente na necikličnim studijskim
                            programima, uključujući i strane studente u mobilnosti na necikličnom programu.
                            Rezultate je moguće filtrirati po akademskoj godini, predmetu i programu necikličnog
                            studija.
                            Ako se predmet ne nalazi na popisu, moguće je da se radi o aktivnosti koja nije vezana za
                            predmet (npr. seminar, stručna praksa, radionica i sl.) — u tom slučaju odaberite opciju
                            „Ostali tipovi aktivnosti". Klikom na dugme „Profil studenta" moguće je pregledati detalje o
                            studentu i njegovom programu.
                        </Message>
                        <CourseGradingTable
                            courses={filteredCourses}
                            marks={marks}
                            loading={loading}
                            onSave={this.handleSave}
                            onShowDetails={this.handleShowDetails}
                            allCourses={courses}
                            getResults={this.getSearchResults}
                            onSearchTextChange={this.handleSearchTextChange}
                        />
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar/>
            </div>
        );
    }
}

export default withRouter(NonCycleStudentGradingList);



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentGradingList.js